import { REMOVE_ACTION, ADD_ACTION } from '~/app/components/FavoriteButton/constants'

export function getFavoritesAction(isFavorite: boolean): string {
  return isFavorite ? REMOVE_ACTION : ADD_ACTION
}
